module.exports = __webpack_public_path__ + "img/what_why_how.b94ca1bd.png";